import Vue from 'vue';
import store from './store';
import Main from './components/Main.vue';
// TODO - remove if not needed
//import BlockItemListing from './components/blocks/BlockItemListing.vue';
import BlockRentals from './components/blocks/BlockRentals.vue';
import BlockSelectedFood from './components/blocks/BlockSelectedFood.vue';
import BlockProducts from './components/blocks/BlockProducts.vue';
import BlockBrowseMenu from './components/blocks/BlockBrowseMenu.vue';
import BlockOurPackages from './components/blocks/BlockOurPackages.vue';


Vue.filter('demoFolder', (img) => {
	return `${window.catermateLocalize.demoFolder}/${img}`;
});

const createNewVueInstance = function(id, component, store, config = {}) {
	if (document.getElementById(id)) {
		new Vue({ // eslint-disable-line no-new
			el: `#${id}`,
			render: (createEl) => createEl(component, config),
			store
		});
	}
};

createNewVueInstance('app', Main, store);
createNewVueInstance('our-packages-vue', BlockOurPackages, store, {props: {type: 'package'}});
createNewVueInstance('rentals-vue', BlockRentals, store);
createNewVueInstance('selected-food-vue', BlockSelectedFood, store);
createNewVueInstance('products-vue', BlockProducts, store);
createNewVueInstance('browse-menu-vue', BlockBrowseMenu, store);

// TODO - remove if not needed
// if (document.querySelector('#our-packages-vue')) {
// 	new Vue({ // eslint-disable-line no-new
// 		el: '#our-packages-vue',
// 		render: (createEl) => createEl(BlockItemListing, {
// 			props: {
// 				type: 'package'
// 			}
// 		}),
// 		store
// 	});
// }

